import { decodeJwtPayload, getStoredAccessToken } from "../utils/authSession";

/**
 * Organisation id from the current access token.
 * Cache keys include this so one tab never reuses another organisation's data.
 * An empty session is "anonymous", never a previous org id.
 */
export function orgScope(token = getStoredAccessToken()) {
  const payload = token ? decodeJwtPayload(token) : null;
  const orgId = payload?.org_id || payload?.organisation_id;
  return orgId ? String(orgId) : "anonymous";
}
